<section class="dts" [attr.data-product]="config.key" [attr.data-shape]="config.shape" (mouseenter)="pause( true )" (mouseleave)="pause( false )">
  <div class="dts-copy">
    <!-- a slide may bring its own eyebrow, icon, name, lead, text, facts, link and note (one product on
         several platforms, the Color Pickers card; one service a slide, Our Services); the config's otherwise -->
    <span class="dts-eyebrow"><img class="dts-eyebrow-logo" [src]="slide.eyebrowLogo || config.eyebrowLogo" alt="" width="18" height="18"/>{{ slide.eyebrow || config.eyebrow }}</span>
    <h2 class="dts-title"><img class="dts-title-icon" [src]="slide.icon || config.icon" alt="" width="48" height="48"/>{{ slide.title || config.title }}</h2>
    <p class="dts-lead">{{ slide.lead || config.lead }}</p>
    <p class="dts-text">{{ slide.text || config.text }}</p>
    <ul class="dts-facts">
      <li *ngFor="let fact of slide.facts || config.facts">{{ fact }}</li>
    </ul>
    <div class="dts-actions">
      <a class="codigrate-button" [routerLink]="slide.link || config.link"><p>{{ config.cta }}</p></a>
      <!-- a product sold on the site (2026-10-14): Add to cart with the price beside it, as in the themes box -->
      <ng-container *ngIf="sellsHere( slide ); else storeButton">
        <button type="button" class="codigrate-button" (click)="addToCart( slide )"><p>Add to cart</p></button>
        <span class="dts-offer" *ngIf="priceOf( slide ) as price">
          <span class="dts-offer-amount">{{ price }}</span>
          <span class="dts-offer-note">One-time purchase</span>
        </span>
        <!-- the product's own store as well, on the row under them (owner 2026-10-14); its Coming Soon note
             there while the listing is not out yet (Tidy Desktop) -->
        <div class="dts-actions-row" *ngIf="slide.store as store; else soonRow">
          <a class="codigrate-button" [href]="store.url" target="_blank" rel="noopener" (click)="onInstall( store, $event )"><p>{{ store.label }}</p></a>
        </div>
        <ng-template #soonRow>
          <div class="dts-actions-row" *ngIf="slide.soon || config.soon as soon"><span class="dts-soon">{{ soon }}</span></div>
        </ng-template>
      </ng-container>
      <ng-template #storeButton>
      <!-- a product that is out: its store button, as on its page; otherwise the Coming Soon note -->
      <a class="codigrate-button" *ngIf="slide.store as store; else soonNote" [href]="store.url" target="_blank" rel="noopener"
         (click)="onInstall( store, $event )"><p>{{ store.label }}</p></a>
      </ng-template>
      <ng-template #soonNote><span class="dts-soon">{{ slide.soon || config.soon }}</span></ng-template>
      <!-- the card has a slide with a second row of buttons (the macOS Color Picker: its App Store under Add to
           cart): every other slide keeps that row's room, empty, so the left side does not move when the
           platform changes (owner 2026-10-14) -->
      <div class="dts-actions-row dts-actions-row-ghost" *ngIf="twoRowCard && !secondRow( slide )" aria-hidden="true">
        <span class="codigrate-button"><p>&nbsp;</p></span>
      </div>
    </div>
  </div>

  <div class="dts-show">
    <!-- the headline of the App Store picture, as text: the accent words, the rest, the line -->
    <div class="dts-head">
      <h3 class="dts-headline"><span class="dts-accent">{{ slide.accent }}</span> {{ slide.rest }}</h3>
      <p class="dts-head-line">{{ slide.line }}</p>
    </div>

    <!-- the picture's scenes, each a picture of its own that opens in the lightbox; one slide over
         another, only the one shown and its neighbours carry a src -->
    <div class="dts-stage">
      <div *ngFor="let s of slides; let i = index; trackBy: trackSlide"
           class="dts-scenes" [class.on]="i === active" [attr.data-layout]="s.layout" [attr.data-slide]="s.key" [style.--count]="s.scenes.length" [attr.aria-hidden]="i !== active">
        <button *ngFor="let sc of s.scenes; trackBy: trackScene" type="button" class="dts-scene"
                [attr.tabindex]="i === active ? 0 : -1" [attr.aria-label]="'Enlarge: ' + sc.name" (click)="enlarge( sc )">
          <img [attr.src]="loaded.has( i ) ? src( sc ) : null" [alt]="sc.alt" [width]="sc.width" [height]="sc.height" decoding="async"/>
          <span class="dts-scene-label" *ngIf="sc.label">{{ sc.label }}</span>
        </button>
      </div>
    </div>

    <div class="dts-picker" role="group" [attr.aria-label]="config.pickerLabel">
      <button *ngFor="let s of slides; let i = index; trackBy: trackSlide" type="button"
              class="dts-pick" [class.on]="i === active" [attr.aria-pressed]="i === active"
              (click)="pick( i )"><img class="dts-pick-logo" *ngIf="s.chipLogo" [src]="s.chipLogo" alt="" width="16" height="16"/>{{ s.chip }}</button>
    </div>
  </div>

  <!-- Lightbox: the theme pages' (src/styles/page/tool-lightbox.scss), as on the product pages -->
  <div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
    <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
      <img [src]="lightbox.large" [alt]="lightbox.alt">
    </figure>
    <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
    <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
    <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
      <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( -1, $event )" aria-label="Previous picture">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      </button>
      <span class="cp-lb-seg td-lb-label">
        <span class="cp-lb-name">
          <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
          <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
        </span>
      </span>
      <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( 1, $event )" aria-label="Next picture">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      </button>
      <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
    </div>
  </div>
  <!-- whatever the page sets at the box's foot, under both columns (Our Services: its references, owner 2026-10-11) -->
  <div class="dts-foot"><ng-content select="[dtsFoot]"></ng-content></div>
</section>
